// src/components/footer2/index.jsx
import React from "react";
import { Facebook, Youtube, Linkedin, Twitter } from "react-feather";
import { Link } from "react-router-dom";
import { logo } from "../imagepath";
import "./footer.css";

export const Footer2 = () => {
  const XIcon = ({ size = 20 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
  >
    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
  </svg>
);

  return (
    <footer className="io-footer" role="contentinfo">
      {/* Üst Bant: Logo + Sosyal */}
      <section className="io-footer__brand">
        <div className="io-wrap">
          <div className="io-footer__brand-left">
            <img src={logo} className="io-footer__logo" alt="İdealonline" />
          </div>

          <div className="io-footer__brand-right">
            <div className="io-footer__social-head">Bizi Takip Edin:</div>
            <ul className="io-footer__social">
              <li>
                <a
                  href="https://www.facebook.com/idealonlinevt/?fref=ts"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                  className="io-socialbtn"
                >
                  <Facebook size={20} />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/idealonlinevt"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="X / Twitter"
                  className="io-socialbtn"
                >
                  <XIcon size={20} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCBHpyTgfElCJAM_exnnBlFQ"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="YouTube"
                  className="io-socialbtn"
                >
                  <Youtube size={20} />
                </a>
              </li>
              <li>
                <a
                  href="https://tr.linkedin.com/in/idealonline-veri-taban%C4%B1-117888136"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn"
                  className="io-socialbtn"
                >
                  <Linkedin size={20} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <hr className="io-footer__divider" />

      {/* Orta Alan: 5 kolon */}
      <section className="io-footer__main">
        <div className="io-wrap io-footer__grid">
          {/* 1) İletişim / Hakkında */}
          <div className="io-fcol">
            <div className="io-contact">
              <div className="io-contact__head">Teknik Destek Hattımız :</div>
              <div className="io-contact__phone">+90 212 528 85 41</div>
              {/* <p className="io-contact__desc">
                İdeal Online, bilimsel araştırmalarınızı desteklemek için
                alanınıza uygun geniş akademik yayın arşivine kolayca
                erişmenizi sağlar.
              </p> */}
              <address className="io-contact__addr">
                Topkapı Mahallesi Kahalbaşı Sokak, No: 31/1&nbsp; Fatih,
                İstanbul / Türkiye&nbsp; 34093.
              </address>
            </div>
          </div>

          {/* 2) Hızlı Erişim */}
          <div className="io-fcol">
            <h4 className="io-fhead">Hızlı Erişim</h4>
            <ul className="io-flist">
              <li><Link to="/about-us">Hakkımızda</Link></li>
              <li><Link to="/contact">İletişim</Link></li>
              <li><Link to="/references">Referanslar</Link></li>
              {/* <li><Link to="/pricing">Paketler</Link></li> */}
              {/* <li><Link to="/faq">SSS</Link></li> */}
              <li><Link to="/help">Yardım</Link></li>
            </ul>
          </div>

          {/* 3) Veri Tabanlarımız */}
          <div className="io-fcol">
            <h4 className="io-fhead">Veri Tabanlarımız</h4>
            <ul className="io-flist">
              <li><Link to="/database/all">Tümü</Link></li>
              <li><Link to="/journal-list/all">İdealonline Süreli Yayınlar</Link></li>
              <li><Link to="/database/İdeal Sosyal Bilimler Veritabanı">İdeal Sosyal Bilimler Veri Tabanı</Link></li>
              <li><Link to="/database/Tıp Kitapları">Tıp Kitapları</Link></li>
              <li><Link to="/database/Din Bilimleri">Din Bilimleri</Link></li>
              <li><Link to="/database/Konferans & Armağanlar">Konferans ve Armağanlar</Link></li>
            </ul>
          </div>

          {/* 4) Hızlı Arama */}
          {/* <div className="io-fcol">
            <h4 className="io-fhead">Hızlı Arama</h4>
            <ul className="io-flist">
              <li><Link to="/publication-list?quick=author">Yazar</Link></li>
              <li><Link to="/publication-list?quick=journal">Dergi</Link></li>
              <li><Link to="/publication-list?quick=book">Kitap</Link></li>
              <li><Link to="/publication-list?type=article">Makale</Link></li>
              <li><Link to="/publication-list?type=issue">Dergi Sayısı</Link></li>
              <li><Link to="/publication-list?type=chapter">Kitap Bölümü</Link></li>
            </ul>
          </div> */}
        
        </div>
      </section>

      <hr className="io-footer__divider" />

      {/* Alt Bant: Telif + Politikalar */}
      <section className="io-footer__bottom">
        <div className="io-wrap io-footer__bottom-row">
          <div className="io-copy">
            ©2025 İdealonline, İdeal Kültür’ün tescilli markasıdır. Tüm
            hakları saklıdır.
          </div>
          <ul className="io-botlinks">
            <li><Link to="/kvkk">KVKK Politikamız ve Gizlilik</Link></li>
          </ul>
        </div>
      </section>
    </footer>
  );
};
